<template>
<div class="chapter">
<div class="inner_page">
<div class="discoverPage">
<div>
<div>
<p><strong>Explore book giveaways, sneak peeks, deals, and more.</strong></p>
<div></div>
</div>
<div><a class="landingPageLink" href="https://discover.hachettebookgroup.com/?ref=9780738214993&amp;discp=0" target="_blank">Tap here to learn more</a>.</div>
</div>
<div class="publisherLogo">
<p class="img"><img alt="Da Capo logo" class="publisherLogoImg" src="Images/publisher-logo.png"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// discover-page_pre.vue?c035558c